import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";
import { RESOLUTIONS } from "./constants";
import type { ResolutionPickerProps } from "./types";

export function ResolutionPicker({
  resolution,
  onResolutionChange,
  availableResolutions,
  className,
}: ResolutionPickerProps) {
  const { t } = useLanguage();
  const resolutions = availableResolutions ?? RESOLUTIONS;

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <h4 className="text-sm font-bold text-foreground mb-1">
        {t.generate.resolution}
      </h4>
      <div className="flex gap-2">
        {resolutions.map((res) => (
          <button
            key={res.id}
            onClick={() => onResolutionChange(res.id)}
            className={cn(
              "flex-1 py-2 px-4 rounded-lg text-sm font-bold transition-all border",
              resolution === res.id
                ? "bg-foreground text-background border-foreground"
                : "bg-background text-foreground border-border hover:border-foreground/50"
            )}
          >
            {res.label}
          </button>
        ))}
      </div>
    </div>
  );
}
